<template lang="pug">
  header.header
    .header__container.container

      .header__left
        transition(name="fade")
          button.header__back-button(v-if="backButton" @click="$router.push('/')")
            v-icon.header__back-button-icon(name="arrow-left")
            span.header__back-button-text Назад

      .header__center
        p.header__title Студия массажа Body Constructor
        p.header__address(v-if="isAddressPicked") {{currentAddress.formatted_address}}

      .header__right
        //transition(name="fade")
          //button.header__forward-button(v-if="forwardUrl" @click="$router.go(-1)")
          //  span.header__forward-button-text Вернуться
          //  v-icon.header__forward-button-icon(name="chevron-right")
</template>

<script>
import {mapGetters} from "vuex";

export default {
  props: {
    backButton: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  computed: {
    ...mapGetters('address', {currentAddress: 'getCurrentAddress'}),
    isAddressPicked() {
      return !!this.currentAddress;
    }
  }
};
</script>

<style lang="scss">
.header {
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.3s;
  }

  /* .fade-leave-active до версии 2.1.8 */
  .fade-enter, .fade-leave-to {
    opacity: 0;
  }
}
</style>
